import { createContext } from 'react';

/** A widget reports going fullscreen so the page can blank the thread behind its card. */
export const WidgetFullscreenContext = createContext<(fullscreen: boolean) => void>(() => {});
